export default {
  name: 'MmUserAgreement',
  components: {},

  setup() {
    document.getElementById('viewport').content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;';
    return {};
  }

};